// Create SplitRumAgent namespace and export it for ESM/CJS imports
// Must use a named import to create the SplitRumAgent namespace (side effects)
export { SplitRumAgent } from './utils/config';
// Pluggable event collectors
export { tti } from './metrics/tti';
export { routeChanges } from './metrics/routeChanges';
export { webVitals } from './metrics/webVitals';
